import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import BaseStudentActivityCard from '@ts-core/core/components/BaseStudentActivityCard';
import { formatDateTime } from '@ts-core/core/utils/dateFormatters';
import { formatScore } from '@ts-core/core/utils/scoreFormatters';

import { StudentPracticeSession } from '../../types';

interface StudentPracticeSessionCardProps {
  loading?: boolean;
  practiceSession?: StudentPracticeSession;

  onPracticeSessionActionClick?: (practiceSession: StudentPracticeSession) => void;
}

const StudentPracticeSessionCard = (props: StudentPracticeSessionCardProps) => {
  const { loading, practiceSession, onPracticeSessionActionClick } = props;
  const intl = useIntl();

  const handlePracticeActionClick = useCallback(() => {
    if (practiceSession && onPracticeSessionActionClick) {
      onPracticeSessionActionClick(practiceSession);
    }
  }, [practiceSession, onPracticeSessionActionClick]);

  return (
    <BaseStudentActivityCard
      loading={loading}
      title={practiceSession?.name}
      subtitle={formatDateTime(practiceSession?.createdAt)}
      score={formatScore(practiceSession?.finished ? practiceSession?.score : undefined, practiceSession?.maxScore)}
      onActionClick={onPracticeSessionActionClick ? handlePracticeActionClick : undefined}
      actionTitle={intl.formatMessage({ id: practiceSession?.finished ? 'generic.button.details' : 'practiceSession.finalize' })}
    />
  );
};

export default StudentPracticeSessionCard;
